// extracted by mini-css-extract-plugin
module.exports = {"GoBackToSchool":"GoBackToSchool_GoBackToSchool__35KGW","Content":"GoBackToSchool_Content__2l-fB","GoBackButton":"GoBackToSchool_GoBackButton__1fqBD"};